export default {
  loggedIn (state) {
    return !!state.authData
  },
  getAuthUserData (state) {
    return state.authData.data.user
  },
  getAuthRefreshTokenData (state) {
    return state.authData.refreshToken
  }
}
